import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function Register() {
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Welcome to POCHE");
      navigate("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="register-page" className="bg-poche-black text-white min-h-[80vh] grid grid-cols-1 md:grid-cols-2">
      <div className="flex items-center justify-center px-8 md:px-16 py-16 order-2 md:order-1">
        <div className="w-full max-w-md">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Create Account</p>
          <h1 className="font-serif text-5xl mt-3">Join the house.</h1>
          <form onSubmit={submit} className="mt-10 space-y-5">
            <Field label="Name" testid="reg-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            <Field label="Email" testid="reg-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            <Field label="Password" testid="reg-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
            <button type="submit" data-testid="reg-submit" disabled={busy} className="btn-gold w-full justify-center disabled:opacity-60">
              {busy ? "Creating…" : "Create Account"}
            </button>
          </form>
          <div className="flex items-center my-7 gap-4 text-[10px] tracking-luxury uppercase text-white/35">
            <div className="flex-1 h-px bg-white/15" />
            <span>Or</span>
            <div className="flex-1 h-px bg-white/15" />
          </div>
          <button data-testid="reg-google" onClick={loginWithGoogle} className="btn-outline-gold w-full justify-center">
            Continue with Google
          </button>
          <p className="text-center mt-8 text-sm text-white/55">
            Already with POCHE? <Link to="/login" className="text-poche-gold underline underline-offset-4">Sign in</Link>
          </p>
        </div>
      </div>
      <div className="hidden md:block relative order-1 md:order-2">
        <img src="/lifestyle/lifestyle_hero.png" className="w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-gradient-to-bl from-black/85 to-transparent" />
        <div className="absolute bottom-10 right-10 max-w-xs text-right">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Membership Privileges</p>
          <h2 className="font-serif text-4xl text-white mt-3">VIP drops. Personal fit. Concierge.</h2>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="text-[10px] tracking-luxury uppercase text-white/55">{label}</label>
      <input data-testid={testid} type={type} value={value} onChange={onChange} required={required} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
    </div>
  );
}
